import { format, formatDistanceToNow } from 'date-fns'

// ----------------------------------------------------------------------

export function fDate(date: string | number | Date) {
  return format(new Date(date), 'dd MMMM yyyy')
}

export function fShortDate(date: string | number | Date) {
  return format(new Date(date), 'dd/MM/yyyy')
}

export function fDateTime(date: string | number | Date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm')
}

export function fDateTimeSuffix(date: string | number | Date) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm p')
}

export function fToNow(date: string | number | Date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  })
}

export function fDateSlash(date: string | number | Date) {
  return format(new Date(date), 'dd/MM/yyyy')
}

export function fDateSlashTime(date: string | number | Date) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
}

export function fDateDashTime(date: string | number | Date) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss')
}